<script setup lang="ts">
import { minValidator, requiredValidator } from "@validators";
import { VForm } from "vuetify/components";
import type { BookingNumberInPartyProps } from "../types/index";

const props = defineProps<BookingNumberInPartyProps>();

const numberInPartyFormRef = ref<InstanceType<typeof VForm>>();

defineExpose({ validate: () => numberInPartyFormRef.value?.validate() });
</script>
<template>
  <VForm ref="numberInPartyFormRef">
    <VRow>
      <VCol cols="12">
        <p class="mb-0">Please indicate how many people are attending (players and non-players) so we can serve you better.</p>
      </VCol>
    </VRow>
    <VRow>
      <VCol cols="12" md="6">
        <VTextField
          v-model="props.form.numberInParty"
          label="Number In Party"
          type="number"
          :rules="[requiredValidator, minValidator(props.form.numberInParty, 1)]"
          min="1"
        />
      </VCol>
    </VRow>
  </VForm>
</template>
